/**
 * Versions marketing mobile (CFBundleShortVersionString / versionName) au format
 * strictement X.Y.Z.
 *
 * ⚠️ Module volontairement SANS import TypeBox : le client mobile l'importe à
 * l'exécution (Metro n'a pas @sinclair/typebox dans son node_modules isolé).
 * Le schéma TypeBox (`mobile_app.schema.ts`) importe le pattern depuis ici.
 */
export const MOBILE_SEMVER_PATTERN = '^\\d+\\.\\d+\\.\\d+$';

const MOBILE_SEMVER_RE = new RegExp(MOBILE_SEMVER_PATTERN);

export const isValidMobileVersion = (version: string): boolean => MOBILE_SEMVER_RE.test(version);

/**
 * Comparaison X.Y.Z numérique (pas de dépendance semver pour trois nombres).
 * Négatif si a < b, positif si a > b, 0 si égales — OU si l'un des formats est
 * inattendu (fail-open : le check min-version ne doit jamais bloquer un device
 * sur une chaîne malformée).
 *
 * SEULE implémentation du comparateur : utilisée par le gate mobile
 * (`packages/mobile/src/lib/minVersion.ts`) et par les tests du endpoint backend
 * (`mobile_app.public.controller.spec.ts`). Ne pas la re-dériver localement.
 */
export const compareMobileVersions = (a: string, b: string): number => {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (Number.isNaN(diff)) return 0;
    if (diff !== 0) return diff;
  }
  return 0;
};
